/* ODETTE — comportamiento del tema: menú, carrito lateral (API Ajax de Shopify), compra rápida en tarjetas,
   selector de variantes del producto, buscador de tonos y carrusel de reels. Portado del prototipo. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = cents => "$" + Math.round(cents / 100).toLocaleString("es-CO");
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const icon = d => `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">${d}</svg>`;

  /* ---------- toast ---------- */
  let toastT;
  const toast = m => { const t = $("#toast"); if (!t) return; t.textContent = m; t.classList.add("on"); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove("on"), 2200); };

  /* ---------- menú móvil ---------- */
  const menuBtn = $("#menuBtn"), nav = $("#mobileNav");
  // menú lateral: abrir/cerrar, bloquear el scroll de la página y cerrar con Escape o tocando fuera
  const setMenu = open => { nav.hidden = !open; menuBtn.setAttribute("aria-expanded", String(open)); document.body.classList.toggle("menu-open", open); if (open) nav.querySelector(".nav-close")?.focus(); };
  menuBtn?.addEventListener("click", () => setMenu(nav.hidden));
  document.querySelectorAll("[data-nav-close]").forEach(el => el.addEventListener("click", () => setMenu(false)));
  addEventListener("keydown", e => { if (e.key === "Escape" && nav && !nav.hidden) { setMenu(false); menuBtn.focus(); } });

  /* ---------- carrito ---------- */
  const drawer = $("#drawer"), scrim = $("#scrim");
  const setCount = n => { const b = $("#cartCount"); if (b) { b.textContent = n; b.hidden = n === 0; } };
  const openCart = () => { drawer.classList.add("on"); drawer.setAttribute("aria-hidden", "false"); scrim.classList.add("on"); setTimeout(() => drawer.querySelector("button")?.focus(), 50); };
  const closeCart = () => { drawer.classList.remove("on"); drawer.setAttribute("aria-hidden", "true"); scrim.classList.remove("on"); };

  const renderCart = cart => {
    setCount(cart.item_count);
    const lines = cart.items.map(i => `
      <div class="line">${i.image ? `<img src="${window.ODETTE.assets}model-${i.handle}-0.jpg" onerror="this.onerror=null;this.src='${i.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2")}'" alt="">` : ""}
        <div><div class="line-top"><b>${esc(i.product_title)}</b><span>${money(i.final_line_price)}</span></div>
          <small>${i.product_has_only_default_variant ? "Kit incluido" : esc(i.variant_title) + " · kit incluido"}</small>
          <div class="line-ctl"><div class="qty"><button data-line="${i.key}" data-d="-1" aria-label="Quitar uno">−</button><span>${i.quantity}</span><button data-line="${i.key}" data-d="1" aria-label="Agregar uno">+</button></div>
          <button class="link-btn" data-rm="${i.key}">Quitar</button></div></div></div>`).join("");
    drawer.innerHTML = `
      <div class="d-head"><h2 id="cartTitle">Tu carrito (${cart.item_count})</h2><button class="icon-btn" data-close aria-label="Cerrar carrito">${icon('<path d="M6 6l12 12M18 6L6 18"/>')}</button></div>
      <div class="ship"><span>${esc(drawer.dataset.freeLabel || "")}</span></div>
      <div class="d-body">${cart.item_count ? lines : `<div class="empty"><p>Tu carrito está vacío.</p><a class="btn btn-solid" href="/collections/all">Ver tonos</a></div>`}</div>
      ${cart.item_count ? `<div class="d-foot"><div class="d-row"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
        <div class="d-row" style="color:var(--muted);font-size:14px"><span>Envío</span><span>Se calcula al pagar</span></div>
        <a class="btn btn-solid btn-price" href="/checkout"><span>Finalizar compra</span><span>${money(cart.total_price)}</span></a>
        <p class="note" style="text-align:center">Tarjeta · Transferencia · Contra entrega en Medellín</p></div>` : ""}`;
  };
  const refresh = () => fetch("/cart.js").then(r => r.json()).then(renderCart);
  const post = (url, body) => fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
    .then(async r => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || "No se pudo agregar"); return j; });
  const add = (id, quantity = 1) => post("/cart/add.js", { items: [{ id: +id, quantity }] })
    .then(() => refresh()).then(() => { openCart(); toast("Agregado al carrito"); })
    .catch(e => toast(e.message));

  $("#cartBtn")?.addEventListener("click", e => { e.preventDefault(); refresh().then(openCart); });
  scrim?.addEventListener("click", closeCart);
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  /* ---------- clics delegados ---------- */
  document.addEventListener("click", e => {
    const el = e.target.closest("button,a"); if (!el) return;
    if (el.dataset.close !== undefined && el.closest("#drawer")) return closeCart();
    if (el.dataset.line) { const qty = +el.closest(".qty").querySelector("span").textContent + +el.dataset.d; post("/cart/change.js", { id: el.dataset.line, quantity: Math.max(0, qty) }).then(renderCart); return; }
    if (el.dataset.rm) { post("/cart/change.js", { id: el.dataset.rm, quantity: 0 }).then(renderCart); return; }
    if (el.dataset.add) { add(el.dataset.add, 1); return; }
    if (el.dataset.cardq) {   // cantidad en el panel de compra de la tarjeta
      const box = el.closest(".card-quick"), span = box.querySelector(".qty-mini span");
      const q = Math.max(1, Math.min(10, +span.textContent + +el.dataset.cardq));
      span.textContent = q; box.querySelector("[data-addq] span").textContent = " · " + money(+box.dataset.price * q);
      return;
    }
    if (el.dataset.addq !== undefined) { const box = el.closest(".card-quick"); add(box.dataset.variant, +box.querySelector(".qty-mini span").textContent); return; }
  });

  /* ---------- producto: variantes y cantidad ---------- */
  const form = $("[data-product-form]");
  if (form) {
    const variants = JSON.parse($("[data-variants]")?.textContent || "[]");
    const selected = variants.length ? [...(variants.find(v => v.id == form.querySelector("[data-variant-input]").value) || variants[0]).options] : [];
    let qty = 1;
    const update = () => {
      const v = variants.find(v => v.options.every((o, i) => o === selected[i]));
      if (!v) return;
      form.querySelector("[data-variant-input]").value = v.id;
      $$("[data-price]").forEach(p => p.textContent = money(v.price));
      $("[data-total]", form).textContent = money(v.price * qty);
      const btn = form.querySelector("[type=submit]"); btn.disabled = !v.available; btn.firstElementChild.textContent = v.available ? "Agregar al carrito" : "Agotado";
      // graduaciones: sin compra en la tienda, se consultan por WhatsApp con la fórmula
      const cta = $("[data-formula-cta]", form);
      if (cta) {
        const rx = /^-/.test(v.option1 || "");
        cta.hidden = !rx; $("[data-formula-note]", form).hidden = !rx; $(".buy-row", form).hidden = rx;
        if (rx) cta.href = `${cta.dataset.wa}?text=${encodeURIComponent(`Hola, quiero consultar disponibilidad del tono ${cta.dataset.tone} con graduación ${v.option1}. Te envío mi fórmula:`)}`;
      }
    };
    form.addEventListener("click", e => {
      const pill = e.target.closest("[data-option]");
      if (pill) { selected[+pill.dataset.option] = pill.dataset.value; $$(`[data-option="${pill.dataset.option}"]`, form).forEach(b => b.setAttribute("aria-pressed", String(b === pill))); const lab = $(`[data-option-label="${pill.dataset.option}"]`, form); if (lab) lab.textContent = pill.dataset.value; update(); }
      const q = e.target.closest("[data-q]");
      if (q) { qty = Math.max(1, Math.min(10, qty + +q.dataset.q)); $("[data-qty]", form).textContent = qty; $("[data-qty-input]", form).value = qty; update(); }
    });
    update();
    form.addEventListener("submit", e => { e.preventDefault(); add(form.querySelector("[data-variant-input]").value, qty); });
  }

  /* ---------- buscador de tonos ---------- */
  const finder = $("[data-finder]");
  if (finder) {
    const fams = JSON.parse($("[data-finder-data]", finder).textContent || "[]");
    let fam = 0, tone = 0;
    const draw = () => {
      const list = fams[fam]?.tones || [], t = list[tone]; if (!t) return;
      $("[data-finder-tones]", finder).innerHTML = list.map((x, i) => `<button type="button" class="iris-btn" data-tone="${i}" aria-pressed="${i === tone}" aria-label="${esc(x.title)}"><img class="iris iris-photo" src="${x.swatch}" alt=""></button>`).join("");
      $("[data-finder-card]", finder).innerHTML = `<img src="${t.image}" alt="Ojo con el tono ${esc(t.title)}">
        <div class="finder-info"><p class="eyebrow">${esc(fams[fam].label)}</p><h3>${esc(t.title)}</h3><p class="price">${t.price}</p>
        ${t.available ? `<button class="btn btn-solid btn-price" data-add="${t.variant}"><span>Agregar al carrito</span><span>${t.price}</span></button>` : `<button class="btn btn-solid" disabled>Agotado</button>`}
        <a href="${t.url}" style="font-size:14px;text-decoration:underline;text-underline-offset:3px">Ver detalles del tono</a></div>`;
    };
    finder.addEventListener("click", e => {
      const f = e.target.closest("[data-fam]"), t = e.target.closest("[data-tone]");
      if (f) { fam = +f.dataset.fam; tone = 0; $$("[data-fam]", finder).forEach(b => b.setAttribute("aria-pressed", String(b === f))); draw(); }
      if (t) { tone = +t.dataset.tone; draw(); }
    });
    draw();
  }

  /* ---------- carrusel de reels ---------- */
  const track = $("#rcTrack");
  if (track && track.children.length) {
    // la lista se repite 3 veces para que el carrusel sea infinito; se trabaja siempre en la copia del medio
    const originals = [...track.children], N = originals.length;
    const clone = () => originals.map(o => { const c = o.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.inert = true; return c; });
    track.prepend(...clone()); track.append(...clone());
    const items = [...track.children];
    let active = -1, inView = true, holdUntil = 0, settle = 0, raf = 0;
    const vid = i => items[i].querySelector("video");
    const near = i => Math.abs(i - active) <= 1;
    // autoplay: el reel activo y sus vecinos se reproducen en silencio; los demás quedan en pausa
    const play = () => items.forEach((it, i) => { const v = vid(i); if (!v) return; v.muted = true; if (inView && near(i)) { if (v.preload !== "auto") v.preload = "auto"; v.play()?.catch(() => {}); } else if (!v.paused) v.pause(); });
    const setActive = i => { if (i === active) return; active = i; items.forEach((it, k) => it.classList.toggle("is-active", k === i)); play(); };
    const leftOf = i => items[i].offsetLeft - track.offsetLeft - (track.clientWidth - items[i].offsetWidth) / 2;
    const jump = i => { track.style.scrollSnapType = "none"; track.scrollLeft = leftOf(i); track.offsetWidth; track.style.scrollSnapType = ""; setActive(i); };
    const normalize = () => { if (active < N || active >= 2 * N) jump(active % N + N); };
    const go = i => { track.scrollTo({ left: leftOf(i), behavior: "smooth" }); setActive(i); clearTimeout(settle); settle = setTimeout(normalize, 700); };
    const nearest = () => { const c = track.scrollLeft + track.clientWidth / 2; let best = 0, d = Infinity; items.forEach((it, i) => { const dd = Math.abs(it.offsetLeft - track.offsetLeft + it.offsetWidth / 2 - c); if (dd < d) { d = dd; best = i; } }); return best; };
    track.addEventListener("scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => setActive(nearest())); clearTimeout(settle); settle = setTimeout(normalize, 250); }, { passive: true });
    // avanza solo cada 5 s; si la persona toca o usa las flechas, espera 8 s antes de seguir
    const touch = () => { holdUntil = Date.now() + 8000; };
    setInterval(() => { if (inView && !document.hidden && Date.now() > holdUntil) go(active + 1); }, 5000);
    ["pointerdown", "wheel", "touchstart"].forEach(ev => track.addEventListener(ev, touch, { passive: true }));
    if ("IntersectionObserver" in window) new IntersectionObserver(([e]) => { inView = e.isIntersecting; play(); }, { threshold: .15 }).observe(track);
    items.forEach((it, i) => it.querySelector(".rc-media")?.addEventListener("click", ev => { if (ev.target.closest("a")) return; touch(); if (i !== active) go(i); else { const v = vid(i); v && (v.paused ? v.play().catch(() => {}) : v.pause()); } }));
    $$("[data-rc]", track.parentElement).forEach(b => b.addEventListener("click", () => { touch(); go(active + +b.dataset.rc); }));
    jump(N);
  }

  /* ---------- efectos al hacer scroll ---------- */
  const view = $("#view");
  const html = document.documentElement;
  const still = !view || !("IntersectionObserver" in window) || matchMedia("(prefers-reduced-motion: reduce)").matches || window.Shopify?.designMode;
  if (still) html.classList.remove("intro");
  else {
    const below = el => el.getBoundingClientRect().top > innerHeight;
    // parte el título en palabras (respetando la cursiva) para que cada una suba por separado
    const splitTitle = (h, delay) => {
      let i = 0;
      const walk = node => [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(w => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.append(w); return; }
            const o = document.createElement("span"); o.className = "tw";
            const inner = document.createElement("span"); inner.textContent = w; inner.style.setProperty("--i", i++);
            o.append(inner); frag.append(o);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
      walk(h);
      if (delay) h.style.setProperty("--d", delay + "ms");
      h.classList.add("split");
    };
    const intro = html.classList.contains("intro") && !!$(".hero", view);
    if (intro) { try { sessionStorage.setItem("odette-intro", "1"); } catch (e) {} setTimeout(() => html.classList.remove("intro"), 2400); }
    else html.classList.remove("intro");
    // títulos: los que ya se ven al cargar quedan quietos, salvo el del hero en la entrada
    const titleIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("t-in"); titleIO.unobserve(e.target); } }), { rootMargin: "0px 0px -10% 0px" });
    $$("h1, h2", view).forEach(h => {
      const hero = intro && h.closest(".hero");
      if (!hero && !below(h)) return;
      splitTitle(h, hero ? 300 : 0);
      titleIO.observe(h);
    });
    // bloques de cada sección; en las grillas, cada tarjeta entra con un pequeño desfase
    const els = [];
    $$("section:not(.hero):not(.trust) > .wrap > *, section > .bands > *, .grid, .fam-grid", view).forEach(el => {
      if (els.includes(el)) return;
      if (el.matches(".grid, .fam-grid")) [...el.children].forEach((c, i) => { if (els.includes(c)) return; c.style.transitionDelay = (i % 4) * 80 + "ms"; els.push(c); });
      else els.push(el);
    });
    const revealIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); revealIO.unobserve(e.target); } }), { rootMargin: "0px 0px -8% 0px" });
    els.forEach(el => { if (below(el)) { el.classList.add("rv"); revealIO.observe(el); } });
  }
})();
